import React from 'react';
import { ModalPortal, Button } from '../../components';
import css from './PackagesBenefitsModal.css';
import {
    LISTING_PACKAGE_ANONYM_LISTING_ID,
    LISTING_PACKAGE_PRIVATE_LISTING_ID,
    LISTING_PACKAGE_SOCIAL_BOOST_ID,
    PROFILE_PACKAGE_SOCIAL_BOOST_ID,
    PROFILE_PACKAGE_ANONYM_PROFILE_ID,
    PROFILE_PACKAGE_PRIVATE_PROFILE_ID,
} from '../../marketplace-custom-config';
import PackagesBenefitsSocialBoost from './PackagesBenefitsSocialBoost';
import PackagesBenefitsAnonymListing from './PackagesBenefitsAnonymListing';
import PackagesBenefitsHiddenListing from './PackagesBenefitsHiddenListing';

const modalContentDictionary = {
    [LISTING_PACKAGE_SOCIAL_BOOST_ID]: props => <PackagesBenefitsSocialBoost {...props} />,
    [LISTING_PACKAGE_ANONYM_LISTING_ID]: props => <PackagesBenefitsAnonymListing {...props} />,
    [LISTING_PACKAGE_PRIVATE_LISTING_ID]: props => <PackagesBenefitsHiddenListing {...props} />,

    [PROFILE_PACKAGE_SOCIAL_BOOST_ID]: props => <PackagesBenefitsSocialBoost {...props} />,
    [PROFILE_PACKAGE_ANONYM_PROFILE_ID]: props => <PackagesBenefitsAnonymListing {...props} />,
    [PROFILE_PACKAGE_PRIVATE_PROFILE_ID]: props => <PackagesBenefitsHiddenListing {...props} />,
};

export default ({ onClose, isOpen, category, currentListing, isProfilePackageType }) => (
    <ModalPortal
        id="PackagesBenefitsModal"
        isOpen={isOpen}
        onClose={onClose}
        contentClassName={css.modalContent}
    >
        {modalContentDictionary[category]({ currentListing, isProfilePackageType })}
        <Button type="button" onClick={onClose}>
            Schliessen
        </Button>
    </ModalPortal>
);
